import './section.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Section = forwardRef(({ className, type, children, ...props }, ref) => (
  <div
    ref={ref}
    className={classNames({
      section: true,
      [`section-${type}`]: type,
      [className]: className,
    })}
    {...props}
  >
    {children}
  </div>
));

Section.propTypes = {
  type: PropTypes.oneOf(['hero', 'product', 'green', 'orange', 'brown', 'blue']),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Section;
